import SpotBannerPage from './SpotBannerPage'
export default SpotBannerPage